export enum AnalyzeView {
    Diversity = 'diversity',
    Inclusion = 'inclusion',
}
